import React from "react";

const Nodata = () => {
  return (
    <div
      style={{
        backgroundColor: "darkgray",
        fontSize: "50px",
        padding: "5px",
        width: "70%",
        margin: "auto",
      }}
    >
      Sorry... Now No product available in this range
    </div>
  );
};

export default Nodata;
